import { ReactNode } from 'react';

import { Container } from '@foradevelopment/fora-ui';

export const ReportContainer = ({ children }: { children: ReactNode }) => {
  return <Container width={['100%', 578]}>{children}</Container>;
};
